var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequirementSpeaker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 17.225C33.1625 17.775 34 19.2562 34 21C34 22.7437 33.1625 24.225 32 24.775V34C32 34.8062 31.5125 35.5375 30.7625 35.85C30.0188 36.1562 29.1562 35.9875 28.5875 35.4125L25.8563 32.6312C22.8563 29.6312 18.7875 28 14.5437 28H14V36C14 37.1062 13.1062 38 12 38H8C6.89563 38 6 37.1062 6 36V28C3.79063 28 2 26.2062 2 24V18C2 15.7937 3.79063 14 6 14H14.5437C18.7875 14 22.8563 12.3125 25.8563 9.31374L28.5875 6.58581C29.1562 6.01384 30.0188 5.84274 30.7625 6.15231C31.5125 6.46187 32 7.19124 32 7.99999V17.225ZM14.5437 18H14V24H14.5437C19.5312 24 24.325 25.8625 28 29.2062V12.7937C24.325 16.1375 19.5312 18 14.5437 18Z",
    fill: "#34A7F0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0004,
    cy: 28.0004,
    r: 9.47205,
    fill: "white",
    stroke: "#47B78E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9121 28.0005L30.4898 31.0671L35.6008 25.9561",
    stroke: "#47B78E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequirementSpeaker);
export default __webpack_public_path__ + "static/media/requirement_speaker.37b8cc9eca2b9ca2b556fe55c14c7ec7.svg";
export { ForwardRef as ReactComponent };